import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Handshake, Factory } from 'lucide-react';

const features = [
  {
    icon: Shield,
    title: "Quality Assurance",
    description: "EN 124 compliant products with consistent quality and reliable production capacity"
  },
  {
    icon: Factory,
    title: "Manufacturing Excellence",
    description: "Long-term contracts with reputed casting manufacturers and modern machine shops"
  },
  {
    icon: Award,
    title: "Industry Standards",
    description: "Products engineered to deliver enhanced performance, safety, and longevity"
  },
  {
    icon: Handshake,
    title: "Trusted Partnerships",
    description: "Strong supply chain and reliable partnerships across multiple sectors"
  }
];

export default function AboutSection() {
  return (
    <section className="py-24 bg-white" id="about">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-[#d4a106] font-medium tracking-wider uppercase text-sm">About Us</span>
            <h2 className="text-4xl md:text-5xl font-light text-[#1a237e] mt-4 mb-6 leading-tight">
              Diversified Engineering 
              <span className="font-medium block">Solutions Group</span>
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Jasmine Enterprises is a diversified engineering solutions group dealing in a wide 
                portfolio of products across <strong className="text-[#1a237e]">ferrous, aluminium, and bronze</strong> categories.
              </p>
              <p>
                With strong stakes and long-term contracts with reputed casting manufacturers and modern 
                machine shops, we ensure consistent quality, reliable production capacity, and highly 
                competitive pricing for our customers.
              </p>
              <p>
                We specialize in supplying ready-to-use iron, steel, and aluminium components including 
                gate valves, sewerage pumps and accessories, water and gas meters, along with 
                customer-specified components used in HT power transmission.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-2 gap-6"
          >
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gray-50 p-6 rounded-2xl hover:shadow-lg transition-all duration-300 group"
              >
                <div className="w-12 h-12 bg-[#1a237e] rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#f9d71c] transition-colors duration-300">
                  <feature.icon className="w-6 h-6 text-white group-hover:text-[#1a237e] transition-colors duration-300" />
                </div>
                <h3 className="text-[#1a237e] font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}